import profileReducer from "./profileSlice";

export default profileReducer;
